'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactI18next = require('react-i18next');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _translate = require('../../helpers/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlourishCheckoutBanner = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _reactCssModules2.default)(_style2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(FlourishCheckoutBanner, _React$Component);

  function FlourishCheckoutBanner() {
    (0, _classCallCheck3.default)(this, FlourishCheckoutBanner);
    return (0, _possibleConstructorReturn3.default)(this, (FlourishCheckoutBanner.__proto__ || (0, _getPrototypeOf2.default)(FlourishCheckoutBanner)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlourishCheckoutBanner, [{
    key: 'renderTextBanner',
    value: function renderTextBanner() {
      var _props = this.props,
          t = _props.t,
          _props$config$store = _props.config.store,
          code = _props$config$store.code,
          textBannerActive = _props$config$store.textBannerActive;


      if (!textBannerActive) {
        return '';
      }

      if (code === 'eukdlx' && new Date() < new Date('2023-01-05T00:00:00.000Z')) {
        return _react2.default.createElement(
          'div',
          { styleName: 'specialnotice' },
          _react2.default.createElement(
            'p',
            null,
            'Thank you for shopping with Dulux. Tester only orders will be fulfilled by Royal Mail and shipped in packs of 3.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Please note if you have purchased more than 3 testers in one order, these may be fulfilled in more than one delivery by Royal Mail.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'For more information please visit our Delivery Information\xA0',
            _react2.default.createElement(
              'a',
              {
                href: '/en/delivery-information',
                style: {
                  color: '#f00',
                  'text-decoration': 'underline',
                  margin: '0px',
                  padding: '0px',
                  'font-size': '14px'
                },
                rel: 'noopener noreferrer',
                target: '_blank'
              },
              'page'
            ),
            '.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Please see below dates for final orders for Christmas & New Year. Last date for ordering for delivery prior to Christmas is:',
            _react2.default.createElement('br', null),
            'Testers Friday 16th December 2022 (subject to Royal Mail service)',
            _react2.default.createElement('br', null),
            'Paint & Accessories Monday 19th December 2022',
            _react2.default.createElement('br', null),
            'We will start dispatching again on 3rd January 2023, however there may be slight delays as we clear our Christmas orders.'
          )
        );
      }

      if (code === 'eukdlx') {
        return _react2.default.createElement(
          'div',
          { styleName: 'specialnotice' },
          _react2.default.createElement(
            'p',
            null,
            'Thank you for shopping with Dulux! For your information, tester only orders will be fulfilled by Royal Mail.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'If you have purchased over 4 testers, these may be fulfilled in more than one delivery.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'For more information please visit our Delivery Information\xA0',
            _react2.default.createElement(
              'a',
              {
                href: '/en/delivery-information',
                style: {
                  color: '#000',
                  'text-decoration': 'underline',
                  margin: '0px',
                  padding: '0px',
                  'font-size': '14px'
                },
                rel: 'noopener noreferrer',
                target: '_blank'
              },
              'page'
            ),
            '.'
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'specialnotice' },
        _react2.default.createElement(
          'p',
          null,
          (0, _translate.contextualTranslation)(t, code, 'spree.show_text_banner_text')
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      // const { t, config: { store: { code } } } = this.props

      return _react2.default.createElement(
        'div',
        null,
        this.renderTextBanner(),
        _react2.default.createElement(
          'div',
          { styleName: this.props.cartStyle },
          _react2.default.createElement(
            'header',
            { styleName: 'checkoutBanner', className: 'clearfix' },
            _react2.default.createElement(
              'div',
              { className: 'container' },
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'checkoutBanner__inner' },
                  this.props.children,
                  _react2.default.createElement(
                    'h2',
                    { styleName: 'checkoutBanner__text', className: 't-title' },
                    this.props.title
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return FlourishCheckoutBanner;
}(_react2.default.Component), _class2.propTypes = {
  title: _react.PropTypes.string.isRequired
}, _class2.defaultProps = {
  cartStyle: ''
}, _temp)) || _class) || _class);
exports.default = FlourishCheckoutBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/CheckoutBanner/flourish.js
// module id = 2271
// module chunks = 0